import React from 'react';
import { Autocomplete, TextField } from '@mui/material';
import { Controller } from 'react-hook-form';
import { useSelector } from 'react-redux';
import { get } from 'lodash';

const TaxSchemeSelect = ({ name, label = 'Tax Scheme', control, errors, readOnly = false, disabled }) => {
  const taxSchemes = useSelector((state) => state.codeLists.taxSchemesList);

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => {
        return (
          <Autocomplete
            {...field}
            id={name}
            options={taxSchemes}
            readOnly={readOnly}
            getOptionLabel={(option) => option}
            renderInput={(params) => (
              <TextField
                {...params}
                data-testid={name}
                label={label}
                error={!!get(errors, name, null)}
                helperText={get(errors, name, {})?.message}
              />
            )}
            isOptionEqualToValue={(option, value) => option === value}
            onChange={(_, value) => field.onChange(value)}
            value={field.value || null} // handle default value
            disabled={disabled}
          />
        );
      }}
    />
  );
};

export default TaxSchemeSelect;
